<div class="modal-header">
  <h4 class="modal-title">Frequently Asked Question's</h4>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <div class="message" *ngFor="let faq of faqs">
    <h5><b>Q:</b>  {{ faq.question }}</h5>
    <p><b>A:</b> {{ faq.answer }}</p>
  </div>

</div>
<div class="modal-footer text-center">
</div>
